import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Checkbox, Grid, Select} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';
import {DefaultColumnFilter} from '../../../../manageOrders/components/internalCommons/TableFilters';
import WtsDealerModal from './dealerModal';
import WtsDealerDetailsModal from '../../../actions/catalogs/dealer.modal';

const {
  getWtsDealer,
  updateWtsDealerStatus,
} = Actions;

function WtsDealer({activeTab}) {
  const wtsDealers = useSelector((state) => state.wtsDealer.dealers);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);
  const dispatch = useDispatch();

  useEffect(() => {
    if (areaSelected && activeTab === 3) {
      dispatch(getWtsDealer(areaSelected.id));
    }
  }, [areaSelected, activeTab]);

  const updateStatus = (e, checkedValue, item) => {
    e.preventDefault();
    dispatch(updateWtsDealerStatus({'data': {...item, 'status': checkedValue ? 'ACTIVO' : 'INACTIVO'}}));
  };

  const SelectColumnFilter = ({
    'column': {filterValue, setFilter},
  }) => {
    const options = [
      {'key': 'all', 'value': '', 'text': 'TODOS'},
      {'key': 'active', 'value': 'ACTIVO', 'text': 'ACTIVO'},
      {'key': 'inactive', 'value': 'INACTIVO', 'text': 'INACTIVO'},
    ];

    return (
      <Select
        compact
        placeholder="TODOS"
        value={filterValue || ''}
        options={options}
        style={{'minWidth': '120px', 'width': '100%'}}
        onChange={(e, {value}) => {
          setFilter(value || '');
          if (!value && areaSelected) {
            dispatch(getWtsDealer(areaSelected.id));
          }
        }}
      />
    );
  };

  const columns = [
    {
      'Header': () => <span className="header-title">RUC</span>,
      'accessor': 'ruc',
    },
    {
      'Header': () => <span className="header-title">DESCRIPCIÓN</span>,
      'accessor': 'description',
    },
    {
      'Header': () => <span className="header-title">NOMBRE CONTROL 2</span>,
      'accessor': 'control_name',
    },
    {
      'Header': () => <span className="header-title">CÓDIGO</span>,
      'accessor': 'code',
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'accessor': 'status',
      'Filter': SelectColumnFilter,
      'filter': (rows, id, filterValue) => {
        if (filterValue === '' || !filterValue) {
          return rows;
        }
        return rows.filter((row) => row.values[id] === filterValue);
      },
      'Cell': (item) => {
        return (
          <Checkbox
            toggle
            checked={item.value === 'ACTIVO'}
            className='green'
            onChange={(e, input) => updateStatus(e, input.checked, item.row.original)}
          />
        );
      },
    },
    {
      'Header': () => <span className="header-title">ACCIONES</span>,
      'id': 'skills_actions',
      'width': 1,
      'Cell': (item) => {
        return (
          <div className='flex center end'>
            <WtsDealerModal mode='edit' delerToEdit={item.row.original} />
          </div>
        );
      },
    },
  ];

  return (
    <Grid padded>
      <Grid.Row style={{'padding': 0}}>
        <Grid.Column textAlign='left' width={14}>
          <WtsDealerModal mode='new' />
        </Grid.Column>
        <Grid.Column width={2} textAlign='right'>
          <WtsDealerDetailsModal />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column floated='left'>
          <CommercialTable
            columns={columns}
            data={wtsDealers}
            defaultColumnFilter={DefaultColumnFilter}
            defaultPagination={10}
            initialState={{
              'filters': [
                {
                  'id': 'status',
                  'value': '',
                },
              ],
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default WtsDealer;
